export const STATUS_LABELS = {
    pending: "جديد",
    confirmed: "مؤكد",
    preparing: "قيد التحضير",
    ready: "جاهز",
    delivered: "مكتمل",
    cancelled: "ملغي",
};

export const STATUS_COLORS = {
    pending: "bg-yellow-100 text-yellow-800",
    confirmed: "bg-sky-100 text-sky-800",
    preparing: "bg-blue-100 text-blue-800",
    ready: "bg-green-100 text-green-800",
    delivered: "bg-gray-100 text-gray-700",
    cancelled: "bg-red-100 text-red-800",
};

export const PAYMENT_STATUS_LABELS = {
    paid: "مدفوع",
    pending: "بانتظار الدفع",
    failed: "فشل الدفع",
    refunded: "مسترجع",
};

export const PAYMENT_STATUS_COLORS = {
    paid: "bg-emerald-100 text-emerald-800",
    pending: "bg-amber-100 text-amber-800",
    failed: "bg-red-100 text-red-800",
    refunded: "bg-purple-100 text-purple-800",
};

export function paymentMethodLabel(method) {
    if (method === "online") return "دفع إلكتروني (Apple Pay / مدى / بطاقة)";
    if (method === "cash") return "كاش";
    if (method === "on_pickup") return "عند الاستلام";
    return "عند التوصيل";
}
